/**
 * Main Application Entry Point
 * Initializes and renders the React application
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers';
import { AppRouter } from './app/router';
import { ErrorBoundary, setupGlobalErrorHandlers } from './core/error-handling';
import { ThemeProvider } from './core/theme';
import './styles/globals.css';

// Setup global error handlers
setupGlobalErrorHandlers();

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Render application
createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider defaultTheme="system" storageKey="app-theme">
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>
);
